"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreviewService = void 0;
const api_1 = require("../api");
class PreviewService {
    constructor(fetch) {
        this.apiVersion = api_1.apiVersion;
        this.fetch = fetch;
    }
    getPreviewToken(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.fetch(`/${this.apiVersion}/preview/tokens`, {
                method: "POST",
                body: JSON.stringify(params),
                headers: {
                    "Content-Type": "application/json",
                },
            });
        });
    }
    /** @deprecated Use the PreviewDataApi instead */
    createPreview(params) {
        return __awaiter(this, void 0, void 0, function* () {
            let resp;
            resp = yield this.fetch(`/${this.apiVersion}/preview`, {
                method: "POST",
                body: JSON.stringify(params),
                headers: {
                    "Content-Type": "application/json",
                },
            });
            // Tag legacy preview objects as "CHANGE" stream producers.
            //
            // Before DE-3061, they were all implicitly change streams,
            // so this maintains legacy behavior.
            if (!("output_stream_type" in resp)) {
                return Object.assign(Object.assign({}, resp), { output_stream_type: "CHANGE" });
            }
            return resp;
        });
    }
    /** @deprecated Use the PreviewDataApi instead */
    getPreview(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const query = params.pagination_token
                ? `?token=${params.pagination_token}`
                : "";
            return this.fetch(`/${this.apiVersion}/preview/${params.id}${query}`);
        });
    }
    getDependencies(sql) {
        return this.fetch(`/${this.apiVersion}/preview/dependencies`, {
            method: "POST",
            body: JSON.stringify({ sql }),
            headers: {
                "Content-Type": "application/json",
            },
        });
    }
}
exports.PreviewService = PreviewService;
exports.default = PreviewService;
